import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 269px;
  height: 332px;
  background: #ffffff;
  border: 1px solid #d1d1d1;
  box-sizing: border-box;
  border-radius: 12px;
`;

export const ImgWrapper = styled.div``;
// change div to img
export const Img = styled.img`
  height: 180px;
  width: 236px;
  /* border: 1px solid blue; */
  border-radius: 12px;
`;

export const Rate = styled.div`
  position: absolute;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: rgb(0, 255, 0);
  margin: 12px 0 0 20px;
`;

export const Title = styled.div`
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  color: #151515;
  margin: 16px 0 5px 0;
`;

export const Text = styled.div`
  font-family: Open Sans;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16.34px;
  color: #575757;
  margin: 4px, 0;
`;

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: auto;
`;

export const Price = styled.div`
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  color: #151515;
`;

export const BuyBtn = styled.button`
  width: 90px;
  height: 36px;
  background: rgb(126, 211, 33);
  border: 1px solid rgb(126, 211, 33);
  box-sizing: border-box;
  border-radius: 8px;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  margin-left: auto;
  cursor: pointer;
  font-family: "SF Pro Display";
  font-style: normal;
  transition-duration: 0.4s;
  transform: scale(.9);
  &:hover {
    background-color: white; /* Green */
    color: rgb(126, 211, 33);
  }
  &:active {
    box-shadow: rgb(126, 211, 33) 0px 3px 10px;
  }
`;

export const DisountWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CrossedDicount = styled.div`
  font-family: Poppins;
  font-style: normal;
  font-size: 12px;
  line-height: 18px;
  text-decoration-line: line-through;
  color: #a9a9a9;
`;
